export const USER_PATHS = {
  change_password_auth_user: 'user/change_password',
};
